<input (change)="onFileChange($event)"
       [attr.disabled]="disabled ? 'disabled' : null"
       accept=".xlsx, .xls"
       id="file"
       type="file"
       data-cy="excel-upload-input"/>

<label [attr.disabled]="disabled ? 'disabled' : null"
       class="button btn-text-link"
       data-cy="excel-upload-label"
       for="file"><span class="iwp-icon-gen_upload"></span><span>Upload Excel</span>
</label>
